import { render, staticRenderFns } from "./RirekishoPreview.vue?vue&type=template&id=ecbb407e&"
import script from "./RirekishoPreview.vue?vue&type=script&lang=js&"
export * from "./RirekishoPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports